/**
 * @fileoverview Flow Editor Vuex getters for computed state values.
 * @module store/modules/floweditor/getters
 */

import { GetterTree } from "vuex/types";
import { RootState } from "@/store/types";
import { FlowEditorState } from "./types";

const getters: GetterTree<FlowEditorState, RootState> = {
  /**
   * Checks if flows are currently being fetched.
   *
   * @param {FlowEditorState} state - Current module state
   * @returns {boolean} True if fetching flows
   */
  isFetchingFlows(state) {
    return state.fetchingFlows;
  },
  /**
   * Gets all sections from all flows.
   *
   * @param {FlowEditorState} state - Current module state
   * @param {Object} getters - Module getters
   * @param {RootState} RootState - Root state
   * @returns {Array[]} Array of section arrays
   */
  sections(state, getters, RootState) {
    const flowsObject = state.flows;
    const allFlows = Object.values(flowsObject);
    const sections = allFlows.map((flow) => {
      return flow.sections;
    });
    return sections;
  },
  /**
   * Gets all flow content nodes.
   *
   * @param {FlowEditorState} state - Current module state
   * @param {Object} getters - Module getters
   * @param {RootState} RootState - Root state
   * @returns {Object} Flow content object
   */
  flowContent(state, getters, RootState) {
    const content = state.contents;
    return content;
  },
};

export default getters;
